
export const PROPERTY_TYPES = {
  SIMPLE: 'simpleValues',
  TRANSLATED: 'translatedValues',
}

export const QUESTION_PROPERTY_COLUMN = 'column'
export const QUESTION_PROPERTY_DESCRIPTION = 'description'
export const QUESTION_PROPERTY_LABEL = 'label'
export const QUESTION_PROPERTY_PLACEHOLDER = 'placeholder'
export const QUESTION_PROPERTY_ROW = 'row'
export const QUESTION_PROPERTY_SIZE = 'size'
export const QUESTION_PROPERTY_TITLE = 'title'
export const QUESTION_PROPERTY_TYPE = 'type'
